<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-shipping"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="{'farmer': theme == 'farmer', 'subdist': theme == 'subdist', 'dist': theme == 'dist', 'sale': theme == 'sale'}">
                <div class="modal-base-header">
                    <navbar
                        :pageName="title"
                        :page="page"
                        :state="state"
                        :userType="theme"
                        :isShowBack="isBack"
                        @clickBack="clickBack"></navbar>
                </div>
                <div class="modal-base-body">
                    <shipping-address-list
                        v-show="state == 'list'"
                        :lbl="lbl"
                        :page="page"
                        :addressList="addressList"
                        :busAddress="busAddress"></shipping-address-list>
                    <shipping-address
                        v-if="state == 'item'"
                        :page="page"
                        :shippingAddress="selectedAddress"
                        :lblShipping="lbl.shipping"
                        :busAddress="busAddress"></shipping-address>
                </div>
                <div class="modal-base-footer">
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
//helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
// import Util from "@/helper/Utility.js";
//error
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//component
import Navbar from "@/components/Layout/NavBar/NavBar.vue";
import ShippingAddress from "./ShippingAddress.vue";
import ShippingAddressList from "./ShippingAddressList.vue";
//model
import { AddressItemModel } from "@/core/Address/model/AddressModel.js";
//service
import BzbsAddress from '@/core/Address/service/BzbsAddress.js';
export default {
    name: 'shipping-modal',
    mixins: [ErrorApiMixin],
    components: {
        Navbar,
        ShippingAddress,
        ShippingAddressList
    },
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            tag: '',
            title: '',
            state: 'list', //list, item
            page: 'profile', //profile, redeem
            isLoading: false,
            isBack: false,

            addressList: [],
            selectedAddress: null,

            busModal: null,
            busAddress: new Vue()
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;

        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.controller.alertModal);
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
        //bus address list
        this.busAddress.$on('clickAdd', this.clickAddAddress);
        this.busAddress.$on('clickEdit', this.clickEditAddress);
        this.busAddress.$on('clickDelete', this.clickDeleteAddress);
        this.busAddress.$on('clickSave', this.clickSaveAddress);
        this.busAddress.$on('addAddress', this.addAddress);
        this.busAddress.$on('editAddress', this.updateAddress);
    },
    methods: {
        //event
        clickAddAddress: function () {
            this.selectedAddress = new AddressItemModel();
            this.state = 'item';
            this.title = this.lbl.shipping.add_address;
        },
        clickEditAddress: function (data) {
            this.selectedAddress = data.address.addressItem;
            this.state = 'item';
            this.title = this.lbl.shipping.edit_address;
        },
        clickDeleteAddress: function (address) {
            this.controller.confirmModal
                .clearText()
                .setTag('shipping-confirm')
                .setTitle(this.lbl.shipping.confirm_delete_headline)
                .setMsg(this.lbl.shipping.confirm_delete_msg)
                .setBtnOk(this.lbl.shipping.confirm_btn_ok)
                .setBtnCancel(this.lbl.shipping.confirm_btn_cancel)
                .show()

            this.controller.confirmModal
                .onClickOk(() => {
                    this.deleteAddress(address);
                });
        },
        clickSaveAddress: function () {
            var address = this.selectedAddress;
            if (address.key) {
                this.updateAddress(address);
            } else {
                this.addAddress(address);
            }
        },
        clickBack: function () {
            if (this.state == 'list') {
                this.hide();
            } else {
                this.state = 'list';
                this.lbl.shipping.select_address;
            }
        },
        //method
        returnSelected: function (address) {
            this.hide();
            this.controller.sendCallbackSelected(address);
        },
        reloadAddress: function () {
            this.state = 'list';
            this.getAddressList();
        },
        //api
        getAddressList: function () {
            var token = Account.getToken();
            BzbsAddress.apiGetAddressList(token)
                .then(res => {
                    this.addressList = [...res];
                    this.hideLoading();
                }).catch(err => {
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        addAddress: function (address) {
            if (this.showLoading()) return;

            var token = Account.getToken();
            BzbsAddress.apiAddAddress(token, address.getParams())
                .then(res => {
                    this.hideLoading();
                    if (this.page == 'detail' || this.page == 'surprisebox')
                        this.returnSelected(res.addressItem);
                    else
                        this.reloadAddress();

                }).catch(err => {
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        updateAddress: function (address) {
            if (this.showLoading()) return;

            var token = Account.getToken();
            BzbsAddress.apiUpdateAddress(token, address.getParams())
                .then(() => {
                    this.hideLoading();
                    this.reloadAddress();
                }).catch(err => {
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        deleteAddress: function (address) {
            if (this.showLoading()) return;

            console.log(address.address.rowKey);
            var token = Account.getToken();
            BzbsAddress.apiDeleteAddres(token, address.address.rowKey)
                .then(() => {
                    this.reloadAddress();
                }).catch(err => {
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                })
        },
        //control
        show: function(config) {
            this.tag = config.tag;
            this.title = this.lbl.shipping.select_address;
            this.page = config.page;
            this.addressList = [];
            this.isBack = config.isBack;

            this.state = 'list';
            this.getAddressList();

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        //relate modal
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.controller.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.controller.loadingModal.hide();
        }
    }
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-shipping {
        @extend %modal-base;

        .modal-dialog {
            max-width: 100vw;

            @media (min-width: $page-max-width) {
                max-width: $page-max-width;
            }

            .modal-content {
                min-height: 100vh;
                border-radius: 0;

                .modal-body {
                    padding: 0;
                    background-image: url(../../../../assets/shared/bg.png);
                    background-repeat: no-repeat;
                    background-color: #ffffff;
                    background-position: center center;
                    background-size: 100% 100%;

                    .modal-base .modal-base-body {
                        padding: 0 28px;

                        @media (max-width: $max-width-mini-mobile) {
                            padding: 0 20px;
                        }
                    }
                }
            }
        }
    }
</style>
